import { Component, Input } from '@angular/core';
import { AiInsights } from '../../../contracts/message.interface';
import { SettingsService } from '../../../../shared/services/settings_service';

@Component({
  standalone: true,
  selector: 'app-message-ai-insights',
  imports: [],
  templateUrl: './message-ai-insights.component.html',
  styleUrl: './message-ai-insights.component.scss',
})
export class MessageAiInsightsComponent {
  @Input() aiInsights: AiInsights | null = null;
  @Input() isSender = false;

  expanded = false;
  copiedPlate: string | null = null;

  constructor(private settingsService: SettingsService) {}

  get audioTranscriptionEnabled(): boolean {
    return this.settingsService.getTenantSettings()?.features?.audioTranscription?.enabled ?? false;
  }

  get plateDetectionEnabled(): boolean {
    return this.settingsService.getTenantSettings()?.features?.plateDetection?.enabled ?? false;
  }

  get hasInsights(): boolean {
    if (!this.aiInsights) return false;
    const hasTranscription = this.audioTranscriptionEnabled && !!this.aiInsights.audioTranscription;
    const hasPlates = this.plateDetectionEnabled && !!this.aiInsights.plateDetection;
    return hasTranscription || hasPlates;
  }

  get isPending(): boolean {
    if (!this.aiInsights) return false;
    const transcriptionPending = this.audioTranscriptionEnabled && this.aiInsights.audioTranscription?.status === 'PENDING';
    const platesPending = this.plateDetectionEnabled && this.aiInsights.plateDetection?.status === 'PENDING';
    return transcriptionPending || platesPending;
  }

  toggle(): void {
    if (!this.isPending) {
      this.expanded = !this.expanded;
    }
  }

  copyPlate(plate: string): void {
    navigator.clipboard.writeText(plate).then(() => {
      this.copiedPlate = plate;
      setTimeout(() => (this.copiedPlate = null), 2000);
    });
  }
}
